<template>

  <v-dialog
    v-model="dialog"
    max-width="900"
    persistent
  >

    <v-card>

      <v-card-title class="d-flex justify-center">
  <span class="text-h5 font-weight-bold">
    Terminales - [{{ config.IdCompania }}] {{ config.NombreCompania }}
  </span>
      </v-card-title>
      <v-card-text>

        <v-row>

          <v-col
            cols="12"
            sm="2"
          ></v-col>
          <v-col
            cols="12"
            sm="4"
          >

            <v-text-field
              v-model="locationCode"
              dense
              label="Location Code"
              outlined
            />

          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              v-model="terminalHiopos"
              dense
              label="Terminal HIOPOS"
              outlined
            />
          </v-col>



          <v-col
            cols="12"
            sm="3"
          >

            <v-btn
              style="
                    background-color: rgb(204 33 40);
                    color: white !important;
                  "
              @click="saveTerminal"
            >
              Agregar
            </v-btn>
          </v-col>
        </v-row>
        <v-alert
          v-show="errorAlert"
          type="warning"
          text
          class="mt-3"
        >
          {{ msgErrorAlert }}
        </v-alert>

        <v-data-table
          :headers="headers"
          :items="terminals"
          class="mt-4"
        >

          <template v-slot:item.LocationCode="{ item }">
            <div class="text-center">
              {{ item.LocationCode }}
            </div>
          </template>

          <template v-slot:item.TerminalHiopos="{ item }">
            <div class="text-center">
              {{ item.TerminalHiopos }}
            </div>
          </template>

          <template v-slot:item.TokenKey="{ item }">
            <div class="text-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    @click="copyToken(item.TokenKey)"
                    v-on="on"
                  >
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </template>

                <span>Copiar Token</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:item.Active="{ item }">
            <div class="d-flex justify-center">
              <v-switch
                v-model="item.Active"
                inset
                @change="changeStatus(item)"
              />
            </div>
          </template>

        </v-data-table>

      </v-card-text>

      <v-card-actions>

        <v-spacer/>

        <v-btn
          text
          @click="close"
        >
          Cerrar
        </v-btn>

      </v-card-actions>

    </v-card>

  </v-dialog>

</template>

<script>

export default {

  props: {

    value: {
      type: Boolean,
      default: false,
    },

    config: {
      type: Object,
      default: () => ({})
    }

  },

  data() {

    return {

      locationCode: '',
      terminalHiopos: '',
      errorAlert: false,
      msgErrorAlert: '',
      headers: [
        {
          text: 'Location Code',
          value: 'LocationCode',
          align: 'center',
        },
        {
          text: 'Terminal HIOPOS',
          value: 'TerminalHiopos',
          align: 'center',
        },
        {
          text: 'Token',
          value: 'TokenKey',
          align: 'center',
          sortable: false,
        },
      ]

    }

  },

  computed: {

    dialog: {

      get() {

        return this.value

      },

      set(value) {

        this.$emit(
          'input',
          value
        )

      }

    },

    terminals() {

      return this.$store.state
        .loyaltyPuntosColombia
        .terminals

    }

  },

  watch: {

    dialog(value) {

      if (value) {
        this.errorAlert = false

        this.msgErrorAlert = ''
        this.loadTerminals()

      }

    }

  },

  methods: {

    loadTerminals() {

      if (!this.config.IdCompania) {

        return

      }

      this.$store.dispatch(
        'loyaltyPuntosColombia/getTerminals',
        this.config.IdCompania
      )

    },

    async saveTerminal() {

      if (!this.locationCode) {
        return
      }

      this.errorAlert = false
      this.msgErrorAlert = ''

      try {

        const response = await this.$store.dispatch(
          'loyaltyPuntosColombia/saveTerminal',
          {
            IdCompania: this.config.IdCompania,
            LocationCode: this.locationCode,
            TerminalHiopos: this.terminalHiopos,
          }
        )

        console.log('Terminal guardado:', response)

        this.locationCode = ''
        this.terminalHiopos = ''

        await this.loadTerminals()

      } catch (error) {

        console.error('Error guardando terminal:', error)

        this.errorAlert = true

        this.msgErrorAlert =
          error.response &&
          error.response.data &&
          error.response.data.message
            ? error.response.data.message
            : 'No fue posible registrar el terminal.'

      }

    },

    async changeStatus(item) {

      await this.$store.dispatch(
        'loyaltyPuntosColombia/changeStatus',
        {
          Id: item.Id,
        }
      )

      this.loadTerminals()

    },

    close() {

      this.dialog = false

    },
    async copyToken(token) {

      try {

        await navigator.clipboard.writeText(token)

        this.$toast.success('Token copiado')

      } catch (e) {

        const input = document.createElement('input')
        input.value = token
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)

        this.$toast.success('Token copiado')

      }

    }

  },

}

</script>

